import React, { useEffect, useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MyContext } from '../context/MyContext';

import Select from 'react-select';

import collaborateursLogo from '../resource/svg/collaborateurs.svg';
import etablissementsLogo from '../resource/svg/etablissement.svg';
import administrateursLogo from '../resource/svg/administrateurs.svg';
import abonnementLogo from '../resource/svg/abonnement.svg';
import fournisseursLogo from '../resource/svg/fournisseurs.svg';
import logoutLogo from '../resource/svg/logout.svg';
import receptionLogo from '../resource/svg/reception.svg';
import huileLogo from '../resource/svg/huile.svg';
import temperatureLogo from '../resource/svg/temperature.svg';
import tracabiliteLogo from '../resource/svg/tracabilite.svg';
import refroidissementLogo from '../resource/svg/refroidissement.svg';
import remiseTemperatureLogo from '../resource/svg/remise.svg';
import nettoyageLogo from '../resource/svg/nettoyage.svg';
import nonConformiteLogo from '../resource/svg/non-conformite.svg';
import mixeLogo from '../resource/svg/mixe.svg';
import exportLogo from '../resource/svg/export.svg';
import fermetureLogo from '../resource/svg/fermeture.svg';
import serviceLogo from '../resource/svg/service.svg';
import sondeLogo from '../resource/svg/sonde.svg';
import { useTranslation } from '../locale/useTranslation';

const etablissementStyle = {
  control: styles => ({ ...styles, backgroundColor: '#FBF7F4', color: '#423F3E' }),
  option: (styles, {isSelected}) => ({ ...styles, backgroundColor: '#FBF7F4', color: '#423F3E', fontWeight: isSelected ? 'bold': 'normal' }),

  placeholder: styles => ({ ...styles, backgroundColor: '#FBF7F4', color: '#423F3E' }),
  singleValue: styles => ({ ...styles, backgroundColor: '#FBF7F4', color: '#423F3E', fontWeight: 'bold' }),

  multiValue: styles => ({ ...styles, backgroundColor: '#FBF7F4', color: '#423F3E' }),
  menuList: styles => ({ ...styles, backgroundColor: '#FBF7F4', borderColor: '#423F3E' }),
  noOptionsMessage: styles => ({ ...styles, backgroundColor: '#FBF7F4', borderColor: '#423F3E' }),

}

function Menu() {
  const { t, language, setLanguage } = useTranslation();
  const { loggedUser, selectedEtablissement, etablissements, setSelectedEtablissement } = useContext(MyContext);


  const [expansionStatus, setExpansionStatus] = useState({
    enceinte: false,
    refroidissement: false,
    remise: false,
    nettoyage: false,
    mixe: false,
    huile: false,
    gestion: false,
    reception:false
  })

  const toggle = (section) => {
    setExpansionStatus((prev) => {
      const newExpansion = Object.keys(prev).reduce((acc, key) => {
        acc[key] = key === section ? !prev[key] : false;
        return acc;
      }, {});

      // Sauvegarde dans sessionStorage
      sessionStorage.setItem("expansion", JSON.stringify(newExpansion));

      return newExpansion;
    });
  };

  useEffect(() => {
    const savedExpansion = sessionStorage.getItem("expansion");
    if (savedExpansion) {
      setExpansionStatus(JSON.parse(savedExpansion));
    }

  }, []);

  const navigate = useNavigate();

  const selectEtablissement = (elt) => {
    setSelectedEtablissement(elt);
    navigate("/etablissement/" + elt.id + "/view");
    sessionStorage.setItem("selectedEtablissement", JSON.stringify(elt));
  }



  const commonMenu = () => {
    const imgSize = {
      width: "35px",
      marginRight: "0.5rem"
    }
    return <>
      <p className="menu-label">
        {t("Mon " + process.env.REACT_APP_TITLE)}
      </p>
      <Select noOptionsMessage={() => t("Aucune correspondance")} options={etablissements} value={selectedEtablissement} onChange={elt => { selectEtablissement(elt) }} placeholder={t("Choisir un établissement") + "..."} styles={etablissementStyle} />
      {
        selectedEtablissement ?
          (<>
            <ul className="menu-list">
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("reception") &&
                <>
                  <li><a onClick={() => toggle("reception")} style={{ verticalAlign: "middle" }}><img src={receptionLogo} style={imgSize} className="vmiddle" alt="" />{t("Contrôles à réception")}
                    {expansionStatus.reception ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.reception ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/fournisseur"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={fournisseursLogo} style={imgSize} className="vmiddle" alt="" />{t("Fournisseurs")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/reception"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={receptionLogo} style={imgSize} className="vmiddle" alt="" />{t("Réceptions réalisées")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("releve_temperature_stockage") &&
                <>
                  <li><a onClick={() => toggle("enceinte")} style={{ verticalAlign: "middle" }}><img src={temperatureLogo} style={imgSize} className="vmiddle" alt="" />{t("T°C enceintes")}
                    {expansionStatus.enceinte ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.enceinte ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/enceinte_stockage"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Enceintes de stockage")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/releve_temperature_stockage"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Relevés de température")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }
              {selectedEtablissement.modules && selectedEtablissement.modules.includes("tracabilite") && <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/tracabilite"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={tracabiliteLogo} style={imgSize} className="vmiddle" alt="" />{t("Traçabilité")}</NavLink></li>}
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("nettoyage") &&
                <>
                  <li><a onClick={() => toggle("nettoyage")} style={{ verticalAlign: "middle" }}><img src={nettoyageLogo} style={imgSize} className="vmiddle" alt="" />{t("Nettoyage")}
                    {expansionStatus.nettoyage ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.nettoyage ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/zone"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Plan de nettoyage")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/nettoyage"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Nettoyages réalisés")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("releve_refroidissement") &&
                <>
                  <li><a onClick={() => toggle("refroidissement")} style={{ verticalAlign: "middle" }}><img src={refroidissementLogo} style={imgSize} className="vmiddle" alt="" />{t("Refroidissement")}
                    {expansionStatus.refroidissement ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.refroidissement ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/cellule_refroidissement"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Cellules de refroidissement")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/releve_refroidissement"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Refroidissements réalisés")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("remise_temp") &&
                <>
                  <li><a onClick={() => toggle("remise")} style={{ verticalAlign: "middle" }}><img src={remiseTemperatureLogo} style={imgSize} className="vmiddle" alt="" />{t("Remise T°C")}
                    {expansionStatus.remise ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.remise ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/enceinte_remise"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Enceintes de remise T°C")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/remise_temp"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Remises en T°C réalisées")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }
              {
                selectedEtablissement.modules && selectedEtablissement.modules.includes("releve_huile") &&
                <>
                  <li><a onClick={() => toggle("huile")} style={{ verticalAlign: "middle" }}><img src={huileLogo} style={imgSize} className="vmiddle" alt="" />{t("Huiles")}
                    {expansionStatus.huile ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.huile ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/friteuse"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Bains friteuses")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/releve_huile"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Contrôle des huiles")}</NavLink></li>
                    </ul>
                  </li>
                </>
              }

              {selectedEtablissement.modules && selectedEtablissement.modules.includes("mixe") &&
                <>
                  <li><a onClick={() => toggle("mixe")} style={{ verticalAlign: "middle" }}><img src={mixeLogo} style={imgSize} className="vmiddle" alt="" />{t("Mixés")}
                    {expansionStatus.mixe ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
                  </a>
                    <ul className={expansionStatus.mixe ? "menu-list" : "menu-list is-hidden"}>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/appareil_mixage"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Appareils de mixage")}</NavLink></li>
                      <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/mixe"} className={({ isActive }) => isActive ? "is-active" : ""}>{t("Mixés réalisés")}</NavLink></li>
                    </ul>
                  </li>
                </>

              }



              {selectedEtablissement.modules && selectedEtablissement.modules.includes("temp_service") && <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/temp_service"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={serviceLogo} style={imgSize} className="vmiddle" alt="" />{t("T°C service/livraison")}</NavLink></li>}




              <li><a onClick={() => toggle("gestion")} style={{ verticalAlign: "middle" }}><img src={exportLogo} style={imgSize} className="vmiddle" alt="" />{t("Gestion du compte")}
                {expansionStatus.gestion ? <i className="fa fa-caret-down" style={{ float: 'right', paddingTop: 4 }} /> : <i className="fa fa-caret-left" style={{ float: 'right', paddingTop: 4 }} />}
              </a>
                <ul className={expansionStatus.gestion ? "menu-list" : "menu-list is-hidden"}>


                  <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/non_conformite"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={nonConformiteLogo} style={imgSize} className="vmiddle" alt="" />{t("Non-conformité")}</NavLink></li>
                  <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/fermeture_etablissement"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={fermetureLogo} style={imgSize} className="vmiddle" alt="" />{t("Fermetures de l'établissement")}</NavLink></li>
                  <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/export"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={exportLogo} style={imgSize} className="vmiddle" alt="" />{t("Exporter des données")}</NavLink></li>
                  <li><NavLink end to={"/etablissement/" + selectedEtablissement.id + "/note"} className={({ isActive }) => isActive ? "is-active" : ""}><img src={nonConformiteLogo} style={imgSize} className="vmiddle" alt="" />{t("Notes")}</NavLink></li>
                </ul>
              </li>
            </ul>
          </>)
          : (<></>)
      }
    </>
  }

  //si besoin de remettre les notes
  //<li><NavLink end to="/note" className={({ isActive }) => isActive ? "is-active" : ""}><img src={nonConformiteLogo} style={imgSize} className="vmiddle" alt="" />Notes</NavLink></li>

  const adminMenu = () => {

    const imgSize = {
      width: "35px",
      marginRight: "0.5rem"
    }

    return <aside className="menu has-text-black " >
      <p className="menu-label">
        {t("Général")}
      </p>
      <ul className="menu-list">
        <li><NavLink end to="/administrateur" className={({ isActive }) => isActive ? "is-active" : ""}><img src={administrateursLogo} style={imgSize} className="vmiddle" alt="" />{t("Administrateurs")}</NavLink></li>
        <li><NavLink end to="/abonnement" className={({ isActive }) => isActive ? "is-active" : ""}><img src={abonnementLogo} style={imgSize} className="vmiddle" alt="" />{t("Abonnements")}</NavLink></li>
        <li><NavLink end to="/etablissement" className={({ isActive }) => isActive ? "is-active" : ""}><img src={etablissementsLogo} style={imgSize} className="vmiddle" alt="" />{t("Etablissements")}</NavLink></li>
        <li><NavLink end to="/utilisateur" className={({ isActive }) => isActive ? "is-active" : ""}><img src={collaborateursLogo} style={imgSize} className="vmiddle" alt="" />{t("Utilisateurs")}</NavLink></li>
        <li><NavLink end to="/sonde" className={({ isActive }) => isActive ? "is-active" : ""}><img src={sondeLogo} style={imgSize} className="vmiddle" alt="" />{t("Sondes")}</NavLink></li>
        <li><NavLink end to="/statistics" className={({isActive}) => isActive ? "is-active": ""}><img src={temperatureLogo} style={imgSize} className="vmiddle" alt="" />{t("Statistiques")}</NavLink></li>


      </ul>
      {
        commonMenu()
      }
    </aside>
  };

  const gerantMenu = () => {

    const imgSize = {
      width: "35px",
      marginRight: "0.5rem"
    }

    return <aside className="menu has-text-black is-fullheight-with-navbar" >
      <p className="menu-label">
        {t("Général")}
      </p>
      <ul className="menu-list">
        <li><NavLink end to="/etablissement" className={({ isActive }) => isActive ? "is-active" : ""}><img src={etablissementsLogo} style={imgSize} className="vmiddle" alt="" />{t("Etablissements")}</NavLink></li>
        <li><NavLink end to="/utilisateur" className={({ isActive }) => isActive ? "is-active" : ""}><img src={collaborateursLogo} style={imgSize} className="vmiddle" alt="" />{t("Utilisateurs")}</NavLink></li>
      </ul>

      {
        commonMenu()
      }
    </aside>
  };

  return (
    <div className="column is-one-fifth has-background-white has-text-black is-fullheight is-narrow">
      {
        loggedUser ?
          (
            loggedUser.role_role_id === 0 || loggedUser.role_role_id === 10
              ? adminMenu()
              : gerantMenu()
          )
          :
          (<></>)
      }
    </div>
  );
}


export default Menu;